import React, {useEffect, useState} from 'react';

function CustomerMobile({sendData, setSendData, initialData, componentData, setComponentData,}) {

  const mobileHandler = (data) => {

    if (initialData?.customerClubData.length === 0) {
      setSendData({
        customerMobile: data,
      })
    }
    let findIt = false
    initialData?.customerClubData?.filter((item) => {
      if (item.mobile === data) {
        setSendData({
          customerMobile: data,
          customerName: item?.name,
          customerAddress: item?.address,
          customerPostalCode: item?.postalCode,
          province: item?.province,
          city: item?.city,
          customerId: item?.customerId,
          usedRemaining: ""
        })
        findIt = true
      } else if (!findIt) {
        setSendData({
          customerMobile: data,
          customerName: "",
          customerAddress: "",
          customerPostalCode: "",
          customerId: "",
          usedRemaining: "",
          province: "",
          city: "",
        })
      }
    })
  }

  return (<div className={"solid-dyna-input"}>
    <label htmlFor="">شماره تماس</label>
    <input
      placeholder={"شماره تماس مشتری"}
      value={sendData?.customerMobile ? sendData?.customerMobile : ""}
      onChange={e => mobileHandler(e.target.value)}
    />
  </div>);
}

export default CustomerMobile;